import {
  AlignItems,
  VerticalAlignItems,
} from 'ag-common-svc/lib/components/administration/template-builder/template-editor-page/models/template-builder-align-items.model';

export enum TemplateBuilderCommonColumnOptionsKeys {
  gap = 'gap',
  borderRadius = 'borderRadius',
  isIndividualBackgroundColor = 'isIndividualBackgroundColor',
  commonContentBackgroundColor = 'commonContentBackgroundColor',
  isIndividualHorizontalAlignments = 'isIndividualHorizontalAlignments',
  commonHorizontalContentAlignments = 'commonHorizontalContentAlignments',
  isIndividualVerticalAlignments = 'isIndividualVerticalAlignments',
  commonVerticalContentAlignments = 'commonVerticalContentAlignments',
}

export class TemplateBuilderCommonColumnsOptions {
  [TemplateBuilderCommonColumnOptionsKeys.gap]: number = 0;
  [TemplateBuilderCommonColumnOptionsKeys.borderRadius]: number = 0;
  [TemplateBuilderCommonColumnOptionsKeys.isIndividualBackgroundColor]: boolean = false;
  [TemplateBuilderCommonColumnOptionsKeys.commonContentBackgroundColor]: string = '';
  [TemplateBuilderCommonColumnOptionsKeys.isIndividualHorizontalAlignments]: boolean = false;
  [TemplateBuilderCommonColumnOptionsKeys.commonHorizontalContentAlignments]: AlignItems = AlignItems.flexStart;
  [TemplateBuilderCommonColumnOptionsKeys.isIndividualVerticalAlignments]: boolean = false;
  [TemplateBuilderCommonColumnOptionsKeys.commonVerticalContentAlignments]: VerticalAlignItems =
    VerticalAlignItems.start;
}
